var At = Object.defineProperty;
var Tt = (e, t, r) => t in e ? At(e, t, { enumerable: !0, configurable: !0, writable: !0, value: r }) : e[t] = r;
var q = (e, t, r) => (Tt(e, typeof t != "symbol" ? t + "" : t, r), r);
import { jsx as ve } from "react/jsx-runtime";
import Ae from "react";
class tt extends Ae.PureComponent {
  render() {
    const {
      component: t,
      children: r,
      ...n
    } = this.props;
    return /* @__PURE__ */ ve(t, { tabIndex: -1, ...n, children: r });
  }
}
q(tt, "defaultProps", {
  component: "div"
});
var Z = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function ae(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var Ct = typeof Z == "object" && Z && Z.Object === Object && Z, rt = Ct, St = rt, wt = typeof self == "object" && self && self.Object === Object && self, Pt = St || wt || Function("return this")(), K = Pt, mt = K, Ot = mt.Symbol, Te = Ot, Oe = Te, at = Object.prototype, Mt = at.hasOwnProperty, jt = at.toString, J = Oe ? Oe.toStringTag : void 0;
function xt(e) {
  var t = Mt.call(e, J), r = e[J];
  try {
    e[J] = void 0;
    var n = !0;
  } catch {
  }
  var o = jt.call(e);
  return n && (t ? e[J] = r : delete e[J]), o;
}
var Et = xt, Kt = Object.prototype, It = Kt.toString;
function Lt(e) {
  return It.call(e);
}
var Dt = Lt, Me = Te, Ht = Et, Ft = Dt, qt = "[object Null]", Gt = "[object Undefined]", je = Me ? Me.toStringTag : void 0;
function Rt(e) {
  return e == null ? e === void 0 ? Gt : qt : je && je in Object(e) ? Ht(e) : Ft(e);
}
var X = Rt;
function Bt(e) {
  return e != null && typeof e == "object";
}
var V = Bt, Nt = X, Ut = V, kt = "[object Boolean]";
function zt(e) {
  return e === !0 || e === !1 || Ut(e) && Nt(e) == kt;
}
var Wt = zt;
const Jt = /* @__PURE__ */ ae(Wt);
function Xt() {
  this.__data__ = [], this.size = 0;
}
var Vt = Xt;
function Yt(e, t) {
  return e === t || e !== e && t !== t;
}
var nt = Yt, Zt = nt;
function Qt(e, t) {
  for (var r = e.length; r--; )
    if (Zt(e[r][0], t))
      return r;
  return -1;
}
var ne = Qt, er = ne, tr = Array.prototype, rr = tr.splice;
function ar(e) {
  var t = this.__data__, r = er(t, e);
  if (r < 0)
    return !1;
  var n = t.length - 1;
  return r == n ? t.pop() : rr.call(t, r, 1), --this.size, !0;
}
var nr = ar, sr = ne;
function ir(e) {
  var t = this.__data__, r = sr(t, e);
  return r < 0 ? void 0 : t[r][1];
}
var or = ir, ur = ne;
function cr(e) {
  return ur(this.__data__, e) > -1;
}
var fr = cr, lr = ne;
function pr(e, t) {
  var r = this.__data__, n = lr(r, e);
  return n < 0 ? (++this.size, r.push([e, t])) : r[n][1] = t, this;
}
var hr = pr, _r = Vt, vr = nr, dr = or, yr = fr, gr = hr;
function B(e) {
  var t = -1, r = e == null ? 0 : e.length;
  for (this.clear(); ++t < r; ) {
    var n = e[t];
    this.set(n[0], n[1]);
  }
}
B.prototype.clear = _r;
B.prototype.delete = vr;
B.prototype.get = dr;
B.prototype.has = yr;
B.prototype.set = gr;
var se = B, $r = se;
function br() {
  this.__data__ = new $r(), this.size = 0;
}
var Ar = br;
function Tr(e) {
  var t = this.__data__, r = t.delete(e);
  return this.size = t.size, r;
}
var Cr = Tr;
function Sr(e) {
  return this.__data__.get(e);
}
var wr = Sr;
function Pr(e) {
  return this.__data__.has(e);
}
var mr = Pr;
function Or(e) {
  var t = typeof e;
  return e != null && (t == "object" || t == "function");
}
var Ce = Or;
const Mr = /* @__PURE__ */ ae(Ce);
var jr = X, xr = Ce, Er = "[object AsyncFunction]", Kr = "[object Function]", Ir = "[object GeneratorFunction]", Lr = "[object Proxy]";
function Dr(e) {
  if (!xr(e))
    return !1;
  var t = jr(e);
  return t == Kr || t == Ir || t == Er || t == Lr;
}
var st = Dr, Hr = K, Fr = Hr["__core-js_shared__"], qr = Fr, pe = qr, xe = function() {
  var e = /[^.]+$/.exec(pe && pe.keys && pe.keys.IE_PROTO || "");
  return e ? "Symbol(src)_1." + e : "";
}();
function Gr(e) {
  return !!xe && xe in e;
}
var Rr = Gr, Br = Function.prototype, Nr = Br.toString;
function Ur(e) {
  if (e != null) {
    try {
      return Nr.call(e);
    } catch {
    }
    try {
      return e + "";
    } catch {
    }
  }
  return "";
}
var it = Ur, kr = st, zr = Rr, Wr = Ce, Jr = it, Xr = /[\\^$.*+?()[\]{}|]/g, Vr = /^\[object .+?Constructor\]$/, Yr = Function.prototype, Zr = Object.prototype, Qr = Yr.toString, ea = Zr.hasOwnProperty, ta = RegExp(
  "^" + Qr.call(ea).replace(Xr, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function ra(e) {
  if (!Wr(e) || zr(e))
    return !1;
  var t = kr(e) ? ta : Vr;
  return t.test(Jr(e));
}
var aa = ra;
function na(e, t) {
  return e == null ? void 0 : e[t];
}
var sa = na, ia = aa, oa = sa;
function ua(e, t) {
  var r = oa(e, t);
  return ia(r) ? r : void 0;
}
var N = ua, ca = N, fa = K, la = ca(fa, "Map"), Se = la, pa = N, ha = pa(Object, "create"), ie = ha, Ee = ie;
function _a() {
  this.__data__ = Ee ? Ee(null) : {}, this.size = 0;
}
var va = _a;
function da(e) {
  var t = this.has(e) && delete this.__data__[e];
  return this.size -= t ? 1 : 0, t;
}
var ya = da, ga = ie, $a = "__lodash_hash_undefined__", ba = Object.prototype, Aa = ba.hasOwnProperty;
function Ta(e) {
  var t = this.__data__;
  if (ga) {
    var r = t[e];
    return r === $a ? void 0 : r;
  }
  return Aa.call(t, e) ? t[e] : void 0;
}
var Ca = Ta, Sa = ie, wa = Object.prototype, Pa = wa.hasOwnProperty;
function ma(e) {
  var t = this.__data__;
  return Sa ? t[e] !== void 0 : Pa.call(t, e);
}
var Oa = ma, Ma = ie, ja = "__lodash_hash_undefined__";
function xa(e, t) {
  var r = this.__data__;
  return this.size += this.has(e) ? 0 : 1, r[e] = Ma && t === void 0 ? ja : t, this;
}
var Ea = xa, Ka = va, Ia = ya, La = Ca, Da = Oa, Ha = Ea;
function U(e) {
  var t = -1, r = e == null ? 0 : e.length;
  for (this.clear(); ++t < r; ) {
    var n = e[t];
    this.set(n[0], n[1]);
  }
}
U.prototype.clear = Ka;
U.prototype.delete = Ia;
U.prototype.get = La;
U.prototype.has = Da;
U.prototype.set = Ha;
var Fa = U, Ke = Fa, qa = se, Ga = Se;
function Ra() {
  this.size = 0, this.__data__ = {
    hash: new Ke(),
    map: new (Ga || qa)(),
    string: new Ke()
  };
}
var Ba = Ra;
function Na(e) {
  var t = typeof e;
  return t == "string" || t == "number" || t == "symbol" || t == "boolean" ? e !== "__proto__" : e === null;
}
var Ua = Na, ka = Ua;
function za(e, t) {
  var r = e.__data__;
  return ka(t) ? r[typeof t == "string" ? "string" : "hash"] : r.map;
}
var oe = za, Wa = oe;
function Ja(e) {
  var t = Wa(this, e).delete(e);
  return this.size -= t ? 1 : 0, t;
}
var Xa = Ja, Va = oe;
function Ya(e) {
  return Va(this, e).get(e);
}
var Za = Ya, Qa = oe;
function en(e) {
  return Qa(this, e).has(e);
}
var tn = en, rn = oe;
function an(e, t) {
  var r = rn(this, e), n = r.size;
  return r.set(e, t), this.size += r.size == n ? 0 : 1, this;
}
var nn = an, sn = Ba, on = Xa, un = Za, cn = tn, fn = nn;
function k(e) {
  var t = -1, r = e == null ? 0 : e.length;
  for (this.clear(); ++t < r; ) {
    var n = e[t];
    this.set(n[0], n[1]);
  }
}
k.prototype.clear = sn;
k.prototype.delete = on;
k.prototype.get = un;
k.prototype.has = cn;
k.prototype.set = fn;
var ot = k, ln = se, pn = Se, hn = ot, _n = 200;
function vn(e, t) {
  var r = this.__data__;
  if (r instanceof ln) {
    var n = r.__data__;
    if (!pn || n.length < _n - 1)
      return n.push([e, t]), this.size = ++r.size, this;
    r = this.__data__ = new hn(n);
  }
  return r.set(e, t), this.size = r.size, this;
}
var dn = vn, yn = se, gn = Ar, $n = Cr, bn = wr, An = mr, Tn = dn;
function z(e) {
  var t = this.__data__ = new yn(e);
  this.size = t.size;
}
z.prototype.clear = gn;
z.prototype.delete = $n;
z.prototype.get = bn;
z.prototype.has = An;
z.prototype.set = Tn;
var Cn = z, Sn = "__lodash_hash_undefined__";
function wn(e) {
  return this.__data__.set(e, Sn), this;
}
var Pn = wn;
function mn(e) {
  return this.__data__.has(e);
}
var On = mn, Mn = ot, jn = Pn, xn = On;
function ee(e) {
  var t = -1, r = e == null ? 0 : e.length;
  for (this.__data__ = new Mn(); ++t < r; )
    this.add(e[t]);
}
ee.prototype.add = ee.prototype.push = jn;
ee.prototype.has = xn;
var En = ee;
function Kn(e, t) {
  for (var r = -1, n = e == null ? 0 : e.length; ++r < n; )
    if (t(e[r], r, e))
      return !0;
  return !1;
}
var In = Kn;
function Ln(e, t) {
  return e.has(t);
}
var Dn = Ln, Hn = En, Fn = In, qn = Dn, Gn = 1, Rn = 2;
function Bn(e, t, r, n, o, i) {
  var f = r & Gn, p = e.length, l = t.length;
  if (p != l && !(f && l > p))
    return !1;
  var u = i.get(e), T = i.get(t);
  if (u && T)
    return u == t && T == e;
  var C = -1, b = !0, P = r & Rn ? new Hn() : void 0;
  for (i.set(e, t), i.set(t, e); ++C < p; ) {
    var m = e[C], O = t[C];
    if (n)
      var M = f ? n(O, m, C, t, e, i) : n(m, O, C, e, t, i);
    if (M !== void 0) {
      if (M)
        continue;
      b = !1;
      break;
    }
    if (P) {
      if (!Fn(t, function(j, x) {
        if (!qn(P, x) && (m === j || o(m, j, r, n, i)))
          return P.push(x);
      })) {
        b = !1;
        break;
      }
    } else if (!(m === O || o(m, O, r, n, i))) {
      b = !1;
      break;
    }
  }
  return i.delete(e), i.delete(t), b;
}
var ut = Bn, Nn = K, Un = Nn.Uint8Array, kn = Un;
function zn(e) {
  var t = -1, r = Array(e.size);
  return e.forEach(function(n, o) {
    r[++t] = [o, n];
  }), r;
}
var Wn = zn;
function Jn(e) {
  var t = -1, r = Array(e.size);
  return e.forEach(function(n) {
    r[++t] = n;
  }), r;
}
var Xn = Jn, Ie = Te, Le = kn, Vn = nt, Yn = ut, Zn = Wn, Qn = Xn, es = 1, ts = 2, rs = "[object Boolean]", as = "[object Date]", ns = "[object Error]", ss = "[object Map]", is = "[object Number]", os = "[object RegExp]", us = "[object Set]", cs = "[object String]", fs = "[object Symbol]", ls = "[object ArrayBuffer]", ps = "[object DataView]", De = Ie ? Ie.prototype : void 0, he = De ? De.valueOf : void 0;
function hs(e, t, r, n, o, i, f) {
  switch (r) {
    case ps:
      if (e.byteLength != t.byteLength || e.byteOffset != t.byteOffset)
        return !1;
      e = e.buffer, t = t.buffer;
    case ls:
      return !(e.byteLength != t.byteLength || !i(new Le(e), new Le(t)));
    case rs:
    case as:
    case is:
      return Vn(+e, +t);
    case ns:
      return e.name == t.name && e.message == t.message;
    case os:
    case cs:
      return e == t + "";
    case ss:
      var p = Zn;
    case us:
      var l = n & es;
      if (p || (p = Qn), e.size != t.size && !l)
        return !1;
      var u = f.get(e);
      if (u)
        return u == t;
      n |= ts, f.set(e, t);
      var T = Yn(p(e), p(t), n, o, i, f);
      return f.delete(e), T;
    case fs:
      if (he)
        return he.call(e) == he.call(t);
  }
  return !1;
}
var _s = hs;
function vs(e, t) {
  for (var r = -1, n = t.length, o = e.length; ++r < n; )
    e[o + r] = t[r];
  return e;
}
var ds = vs, ys = Array.isArray, we = ys, gs = ds, $s = we;
function bs(e, t, r) {
  var n = t(e);
  return $s(e) ? n : gs(n, r(e));
}
var As = bs;
function Ts(e, t) {
  for (var r = -1, n = e == null ? 0 : e.length, o = 0, i = []; ++r < n; ) {
    var f = e[r];
    t(f, r, e) && (i[o++] = f);
  }
  return i;
}
var Cs = Ts;
function Ss() {
  return [];
}
var ws = Ss, Ps = Cs, ms = ws, Os = Object.prototype, Ms = Os.propertyIsEnumerable, He = Object.getOwnPropertySymbols, js = He ? function(e) {
  return e == null ? [] : (e = Object(e), Ps(He(e), function(t) {
    return Ms.call(e, t);
  }));
} : ms, xs = js;
function Es(e, t) {
  for (var r = -1, n = Array(e); ++r < e; )
    n[r] = t(r);
  return n;
}
var Ks = Es, Is = X, Ls = V, Ds = "[object Arguments]";
function Hs(e) {
  return Ls(e) && Is(e) == Ds;
}
var Fs = Hs, Fe = Fs, qs = V, ct = Object.prototype, Gs = ct.hasOwnProperty, Rs = ct.propertyIsEnumerable, Bs = Fe(/* @__PURE__ */ function() {
  return arguments;
}()) ? Fe : function(e) {
  return qs(e) && Gs.call(e, "callee") && !Rs.call(e, "callee");
}, Ns = Bs, te = { exports: {} };
function Us() {
  return !1;
}
var ks = Us;
te.exports;
(function(e, t) {
  var r = K, n = ks, o = t && !t.nodeType && t, i = o && !0 && e && !e.nodeType && e, f = i && i.exports === o, p = f ? r.Buffer : void 0, l = p ? p.isBuffer : void 0, u = l || n;
  e.exports = u;
})(te, te.exports);
var ft = te.exports, zs = 9007199254740991, Ws = /^(?:0|[1-9]\d*)$/;
function Js(e, t) {
  var r = typeof e;
  return t = t ?? zs, !!t && (r == "number" || r != "symbol" && Ws.test(e)) && e > -1 && e % 1 == 0 && e < t;
}
var Xs = Js, Vs = 9007199254740991;
function Ys(e) {
  return typeof e == "number" && e > -1 && e % 1 == 0 && e <= Vs;
}
var lt = Ys, Zs = X, Qs = lt, ei = V, ti = "[object Arguments]", ri = "[object Array]", ai = "[object Boolean]", ni = "[object Date]", si = "[object Error]", ii = "[object Function]", oi = "[object Map]", ui = "[object Number]", ci = "[object Object]", fi = "[object RegExp]", li = "[object Set]", pi = "[object String]", hi = "[object WeakMap]", _i = "[object ArrayBuffer]", vi = "[object DataView]", di = "[object Float32Array]", yi = "[object Float64Array]", gi = "[object Int8Array]", $i = "[object Int16Array]", bi = "[object Int32Array]", Ai = "[object Uint8Array]", Ti = "[object Uint8ClampedArray]", Ci = "[object Uint16Array]", Si = "[object Uint32Array]", g = {};
g[di] = g[yi] = g[gi] = g[$i] = g[bi] = g[Ai] = g[Ti] = g[Ci] = g[Si] = !0;
g[ti] = g[ri] = g[_i] = g[ai] = g[vi] = g[ni] = g[si] = g[ii] = g[oi] = g[ui] = g[ci] = g[fi] = g[li] = g[pi] = g[hi] = !1;
function wi(e) {
  return ei(e) && Qs(e.length) && !!g[Zs(e)];
}
var Pi = wi;
function mi(e) {
  return function(t) {
    return e(t);
  };
}
var Oi = mi, re = { exports: {} };
re.exports;
(function(e, t) {
  var r = rt, n = t && !t.nodeType && t, o = n && !0 && e && !e.nodeType && e, i = o && o.exports === n, f = i && r.process, p = function() {
    try {
      var l = o && o.require && o.require("util").types;
      return l || f && f.binding && f.binding("util");
    } catch {
    }
  }();
  e.exports = p;
})(re, re.exports);
var Mi = re.exports, ji = Pi, xi = Oi, qe = Mi, Ge = qe && qe.isTypedArray, Ei = Ge ? xi(Ge) : ji, pt = Ei, Ki = Ks, Ii = Ns, Li = we, Di = ft, Hi = Xs, Fi = pt, qi = Object.prototype, Gi = qi.hasOwnProperty;
function Ri(e, t) {
  var r = Li(e), n = !r && Ii(e), o = !r && !n && Di(e), i = !r && !n && !o && Fi(e), f = r || n || o || i, p = f ? Ki(e.length, String) : [], l = p.length;
  for (var u in e)
    (t || Gi.call(e, u)) && !(f && // Safari 9 has enumerable `arguments.length` in strict mode.
    (u == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    o && (u == "offset" || u == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    i && (u == "buffer" || u == "byteLength" || u == "byteOffset") || // Skip index properties.
    Hi(u, l))) && p.push(u);
  return p;
}
var Bi = Ri, Ni = Object.prototype;
function Ui(e) {
  var t = e && e.constructor, r = typeof t == "function" && t.prototype || Ni;
  return e === r;
}
var ki = Ui;
function zi(e, t) {
  return function(r) {
    return e(t(r));
  };
}
var Wi = zi, Ji = Wi, Xi = Ji(Object.keys, Object), Vi = Xi, Yi = ki, Zi = Vi, Qi = Object.prototype, eo = Qi.hasOwnProperty;
function to(e) {
  if (!Yi(e))
    return Zi(e);
  var t = [];
  for (var r in Object(e))
    eo.call(e, r) && r != "constructor" && t.push(r);
  return t;
}
var ro = to, ao = st, no = lt;
function so(e) {
  return e != null && no(e.length) && !ao(e);
}
var io = so, oo = Bi, uo = ro, co = io;
function fo(e) {
  return co(e) ? oo(e) : uo(e);
}
var lo = fo, po = As, ho = xs, _o = lo;
function vo(e) {
  return po(e, _o, ho);
}
var yo = vo, Re = yo, go = 1, $o = Object.prototype, bo = $o.hasOwnProperty;
function Ao(e, t, r, n, o, i) {
  var f = r & go, p = Re(e), l = p.length, u = Re(t), T = u.length;
  if (l != T && !f)
    return !1;
  for (var C = l; C--; ) {
    var b = p[C];
    if (!(f ? b in t : bo.call(t, b)))
      return !1;
  }
  var P = i.get(e), m = i.get(t);
  if (P && m)
    return P == t && m == e;
  var O = !0;
  i.set(e, t), i.set(t, e);
  for (var M = f; ++C < l; ) {
    b = p[C];
    var j = e[b], x = t[b];
    if (n)
      var Y = f ? n(x, j, b, t, e, i) : n(j, x, b, e, t, i);
    if (!(Y === void 0 ? j === x || o(j, x, r, n, i) : Y)) {
      O = !1;
      break;
    }
    M || (M = b == "constructor");
  }
  if (O && !M) {
    var D = e.constructor, H = t.constructor;
    D != H && "constructor" in e && "constructor" in t && !(typeof D == "function" && D instanceof D && typeof H == "function" && H instanceof H) && (O = !1);
  }
  return i.delete(e), i.delete(t), O;
}
var To = Ao, Co = N, So = K, wo = Co(So, "DataView"), Po = wo, mo = N, Oo = K, Mo = mo(Oo, "Promise"), jo = Mo, xo = N, Eo = K, Ko = xo(Eo, "Set"), Io = Ko, Lo = N, Do = K, Ho = Lo(Do, "WeakMap"), Fo = Ho, de = Po, ye = Se, ge = jo, $e = Io, be = Fo, ht = X, W = it, Be = "[object Map]", qo = "[object Object]", Ne = "[object Promise]", Ue = "[object Set]", ke = "[object WeakMap]", ze = "[object DataView]", Go = W(de), Ro = W(ye), Bo = W(ge), No = W($e), Uo = W(be), G = ht;
(de && G(new de(new ArrayBuffer(1))) != ze || ye && G(new ye()) != Be || ge && G(ge.resolve()) != Ne || $e && G(new $e()) != Ue || be && G(new be()) != ke) && (G = function(e) {
  var t = ht(e), r = t == qo ? e.constructor : void 0, n = r ? W(r) : "";
  if (n)
    switch (n) {
      case Go:
        return ze;
      case Ro:
        return Be;
      case Bo:
        return Ne;
      case No:
        return Ue;
      case Uo:
        return ke;
    }
  return t;
});
var ko = G, _e = Cn, zo = ut, Wo = _s, Jo = To, We = ko, Je = we, Xe = ft, Xo = pt, Vo = 1, Ve = "[object Arguments]", Ye = "[object Array]", Q = "[object Object]", Yo = Object.prototype, Ze = Yo.hasOwnProperty;
function Zo(e, t, r, n, o, i) {
  var f = Je(e), p = Je(t), l = f ? Ye : We(e), u = p ? Ye : We(t);
  l = l == Ve ? Q : l, u = u == Ve ? Q : u;
  var T = l == Q, C = u == Q, b = l == u;
  if (b && Xe(e)) {
    if (!Xe(t))
      return !1;
    f = !0, T = !1;
  }
  if (b && !T)
    return i || (i = new _e()), f || Xo(e) ? zo(e, t, r, n, o, i) : Wo(e, t, l, r, n, o, i);
  if (!(r & Vo)) {
    var P = T && Ze.call(e, "__wrapped__"), m = C && Ze.call(t, "__wrapped__");
    if (P || m) {
      var O = P ? e.value() : e, M = m ? t.value() : t;
      return i || (i = new _e()), o(O, M, r, n, i);
    }
  }
  return b ? (i || (i = new _e()), Jo(e, t, r, n, o, i)) : !1;
}
var Qo = Zo, eu = Qo, Qe = V;
function _t(e, t, r, n, o) {
  return e === t ? !0 : e == null || t == null || !Qe(e) && !Qe(t) ? e !== e && t !== t : eu(e, t, r, n, _t, o);
}
var tu = _t, ru = tu;
function au(e, t) {
  return ru(e, t);
}
var nu = au;
const vt = /* @__PURE__ */ ae(nu);
var dt = { exports: {} };
(function(e) {
  (function(t, r, n) {
    if (!t)
      return;
    for (var o = {
      8: "backspace",
      9: "tab",
      13: "enter",
      16: "shift",
      17: "ctrl",
      18: "alt",
      20: "capslock",
      27: "esc",
      32: "space",
      33: "pageup",
      34: "pagedown",
      35: "end",
      36: "home",
      37: "left",
      38: "up",
      39: "right",
      40: "down",
      45: "ins",
      46: "del",
      91: "meta",
      93: "meta",
      224: "meta"
    }, i = {
      106: "*",
      107: "+",
      109: "-",
      110: ".",
      111: "/",
      186: ";",
      187: "=",
      188: ",",
      189: "-",
      190: ".",
      191: "/",
      192: "`",
      219: "[",
      220: "\\",
      221: "]",
      222: "'"
    }, f = {
      "~": "`",
      "!": "1",
      "@": "2",
      "#": "3",
      $: "4",
      "%": "5",
      "^": "6",
      "&": "7",
      "*": "8",
      "(": "9",
      ")": "0",
      _: "-",
      "+": "=",
      ":": ";",
      '"': "'",
      "<": ",",
      ">": ".",
      "?": "/",
      "|": "\\"
    }, p = {
      option: "alt",
      command: "meta",
      return: "enter",
      escape: "esc",
      plus: "+",
      mod: /Mac|iPod|iPhone|iPad/.test(navigator.platform) ? "meta" : "ctrl"
    }, l, u = 1; u < 20; ++u)
      o[111 + u] = "f" + u;
    for (u = 0; u <= 9; ++u)
      o[u + 96] = u.toString();
    function T(a, s, h) {
      if (a.addEventListener) {
        a.addEventListener(s, h, !1);
        return;
      }
      a.attachEvent("on" + s, h);
    }
    function C(a) {
      if (a.type == "keypress") {
        var s = String.fromCharCode(a.which);
        return a.shiftKey || (s = s.toLowerCase()), s;
      }
      return o[a.which] ? o[a.which] : i[a.which] ? i[a.which] : String.fromCharCode(a.which).toLowerCase();
    }
    function b(a, s) {
      return a.sort().join(",") === s.sort().join(",");
    }
    function P(a) {
      var s = [];
      return a.shiftKey && s.push("shift"), a.altKey && s.push("alt"), a.ctrlKey && s.push("ctrl"), a.metaKey && s.push("meta"), s;
    }
    function m(a) {
      if (a.preventDefault) {
        a.preventDefault();
        return;
      }
      a.returnValue = !1;
    }
    function O(a) {
      if (a.stopPropagation) {
        a.stopPropagation();
        return;
      }
      a.cancelBubble = !0;
    }
    function M(a) {
      return a == "shift" || a == "ctrl" || a == "alt" || a == "meta";
    }
    function j() {
      if (!l) {
        l = {};
        for (var a in o)
          a > 95 && a < 112 || o.hasOwnProperty(a) && (l[o[a]] = a);
      }
      return l;
    }
    function x(a, s, h) {
      return h || (h = j()[a] ? "keydown" : "keypress"), h == "keypress" && s.length && (h = "keydown"), h;
    }
    function Y(a) {
      return a === "+" ? ["+"] : (a = a.replace(/\+{2}/g, "+plus"), a.split("+"));
    }
    function D(a, s) {
      var h, A, I, F = [];
      for (h = Y(a), I = 0; I < h.length; ++I)
        A = h[I], p[A] && (A = p[A]), s && s != "keypress" && f[A] && (A = f[A], F.push("shift")), M(A) && F.push(A);
      return s = x(A, F, s), {
        key: A,
        modifiers: F,
        action: s
      };
    }
    function H(a, s) {
      return a === null || a === r ? !1 : a === s ? !0 : H(a.parentNode, s);
    }
    function S(a) {
      var s = this;
      if (a = a || r, !(s instanceof S))
        return new S(a);
      s.target = a, s._callbacks = {}, s._directMap = {};
      var h = {}, A, I = !1, F = !1, ue = !1;
      function ce(c) {
        c = c || {};
        var v = !1, y;
        for (y in h) {
          if (c[y]) {
            v = !0;
            continue;
          }
          h[y] = 0;
        }
        v || (ue = !1);
      }
      function Pe(c, v, y, _, $, E) {
        var d, w, R = [], L = y.type;
        if (!s._callbacks[c])
          return [];
        for (L == "keyup" && M(c) && (v = [c]), d = 0; d < s._callbacks[c].length; ++d)
          if (w = s._callbacks[c][d], !(!_ && w.seq && h[w.seq] != w.level) && L == w.action && (L == "keypress" && !y.metaKey && !y.ctrlKey || b(v, w.modifiers))) {
            var $t = !_ && w.combo == $, bt = _ && w.seq == _ && w.level == E;
            ($t || bt) && s._callbacks[c].splice(d, 1), R.push(w);
          }
        return R;
      }
      function fe(c, v, y, _) {
        s.stopCallback(v, v.target || v.srcElement, y, _) || c(v, y) === !1 && (m(v), O(v));
      }
      s._handleKey = function(c, v, y) {
        var _ = Pe(c, v, y), $, E = {}, d = 0, w = !1;
        for ($ = 0; $ < _.length; ++$)
          _[$].seq && (d = Math.max(d, _[$].level));
        for ($ = 0; $ < _.length; ++$) {
          if (_[$].seq) {
            if (_[$].level != d)
              continue;
            w = !0, E[_[$].seq] = 1, fe(_[$].callback, y, _[$].combo, _[$].seq);
            continue;
          }
          w || fe(_[$].callback, y, _[$].combo);
        }
        var R = y.type == "keypress" && F;
        y.type == ue && !M(c) && !R && ce(E), F = w && y.type == "keydown";
      };
      function le(c) {
        typeof c.which != "number" && (c.which = c.keyCode);
        var v = C(c);
        if (v) {
          if (c.type == "keyup" && I === v) {
            I = !1;
            return;
          }
          s.handleKey(v, P(c), c);
        }
      }
      function yt() {
        clearTimeout(A), A = setTimeout(ce, 1e3);
      }
      function gt(c, v, y, _) {
        h[c] = 0;
        function $(L) {
          return function() {
            ue = L, ++h[c], yt();
          };
        }
        function E(L) {
          fe(y, L, c), _ !== "keyup" && (I = C(L)), setTimeout(ce, 10);
        }
        for (var d = 0; d < v.length; ++d) {
          var w = d + 1 === v.length, R = w ? E : $(_ || D(v[d + 1]).action);
          me(v[d], R, _, c, d);
        }
      }
      function me(c, v, y, _, $) {
        s._directMap[c + ":" + y] = v, c = c.replace(/\s+/g, " ");
        var E = c.split(" "), d;
        if (E.length > 1) {
          gt(c, E, v, y);
          return;
        }
        d = D(c, y), s._callbacks[d.key] = s._callbacks[d.key] || [], Pe(d.key, d.modifiers, { type: d.action }, _, c, $), s._callbacks[d.key][_ ? "unshift" : "push"]({
          callback: v,
          modifiers: d.modifiers,
          action: d.action,
          seq: _,
          level: $,
          combo: c
        });
      }
      s._bindMultiple = function(c, v, y) {
        for (var _ = 0; _ < c.length; ++_)
          me(c[_], v, y);
      }, T(a, "keypress", le), T(a, "keydown", le), T(a, "keyup", le);
    }
    S.prototype.bind = function(a, s, h) {
      var A = this;
      return a = a instanceof Array ? a : [a], A._bindMultiple.call(A, a, s, h), A;
    }, S.prototype.unbind = function(a, s) {
      var h = this;
      return h.bind.call(h, a, function() {
      }, s);
    }, S.prototype.trigger = function(a, s) {
      var h = this;
      return h._directMap[a + ":" + s] && h._directMap[a + ":" + s]({}, a), h;
    }, S.prototype.reset = function() {
      var a = this;
      return a._callbacks = {}, a._directMap = {}, a;
    }, S.prototype.stopCallback = function(a, s) {
      var h = this;
      if ((" " + s.className + " ").indexOf(" mousetrap ") > -1 || H(s, h.target))
        return !1;
      if ("composedPath" in a && typeof a.composedPath == "function") {
        var A = a.composedPath()[0];
        A !== a.target && (s = A);
      }
      return s.tagName == "INPUT" || s.tagName == "SELECT" || s.tagName == "TEXTAREA" || s.isContentEditable;
    }, S.prototype.handleKey = function() {
      var a = this;
      return a._handleKey.apply(a, arguments);
    }, S.addKeycodes = function(a) {
      for (var s in a)
        a.hasOwnProperty(s) && (o[s] = a[s]);
      l = null;
    }, S.init = function() {
      var a = S(r);
      for (var s in a)
        s.charAt(0) !== "_" && (S[s] = /* @__PURE__ */ function(h) {
          return function() {
            return a[h].apply(a, arguments);
          };
        }(s));
    }, S.init(), t.Mousetrap = S, e.exports && (e.exports = S), typeof n == "function" && n.amd && n(function() {
      return S;
    });
  })(typeof window < "u" ? window : null, typeof window < "u" ? document : null);
})(dt);
var su = dt.exports;
const iu = /* @__PURE__ */ ae(su), ou = (e, t) => !vt(e, t), uu = (e, t) => {
  if (!e)
    return [];
  const r = e[t];
  return r ? Array.isArray(r) ? r : [r] : [t];
}, et = Ae.createContext({
  hotKeyParent: null,
  hotKeyMap: null
});
class cu extends Ae.Component {
  constructor(r, n) {
    super(r, n);
    q(this, "__isFocused__", !1);
    q(this, "__hotKeyMap__", null);
    q(this, "__mousetrap__", null);
    q(this, "__lastChildSequence__", null);
    this.onFocus = this.onFocus.bind(this), this.onBlur = this.onBlur.bind(this);
  }
  /**
   * Constructs the context object that contains references to this component
   * and its KeyMap so that they may be accessed by any descendant HotKeys
   * components
   */
  getContext() {
    return {
      hotKeyParent: this,
      hotKeyMap: this.__hotKeyMap__
    };
  }
  /**
   * Sets this components KeyMap from its keyMap prop and the KeyMap of its
   * ancestor KeyMap component (if one exists)
   */
  componentWillMount() {
    this.updateMap();
  }
  /**
   * Updates this component's KeyMap if either its own keyMap prop has changed
   * or its ancestor's KeyMap has been update
   *
   * @returns Whether the KeyMap was updated
   */
  updateMap() {
    const r = this.buildMap();
    return vt(r, this.__hotKeyMap__) ? !1 : (this.__hotKeyMap__ = r, !0);
  }
  /**
   * This component's KeyMap merged with that of its most direct ancestor that is a
   * HotKeys component. This component's mappings take precedence over those defined
   * in its ancestor.
   */
  buildMap() {
    const r = this.context.hotKeyMap || {}, n = this.props.keyMap || {};
    return { ...r, ...n };
  }
  /**
   * This component's KeyMap
   */
  getMap() {
    return this.__hotKeyMap__ || {};
  }
  /**
   * Imports mousetrap and stores a reference to it on the this component
   */
  componentDidMount() {
    var n;
    const r = "attach" in this.props ? this.props.attach : (n = this.props.attachRef) == null ? void 0 : n.current;
    r && (this.__mousetrap__ = new iu(r), this.updateHotKeys(!0));
  }
  /**
   * Updates this component's KeyMap and synchronises the handlers across to
   * Mousetrap after the component has been updated (passed new prop values)
   */
  componentDidUpdate(r) {
    this.updateHotKeys(!1, r);
  }
  componentWillUnmount() {
    this.context.hotKeyParent && this.context.hotKeyParent.childHandledSequence(null), this.__mousetrap__ && this.__mousetrap__.reset();
  }
  /**
   * Updates this component's KeyMap and synchronises the changes across
   * to Mouestrap
   */
  updateHotKeys(r = !1, n = {}) {
    const { handlers: o = {} } = this.props, { handlers: i = o } = n, f = this.updateMap();
    (r || f || ou(o, i)) && (this.context.hotKeyParent && this.context.hotKeyParent.childHandledSequence(null), this.syncHandlersToMousetrap());
  }
  /**
   * Synchronises the KeyMap and handlers applied to this component over to
   * Mousetrap
   */
  syncHandlersToMousetrap() {
    const { handlers: r = {} } = this.props, n = this.getMap(), o = [], i = this.__mousetrap__;
    Object.keys(r).forEach((f) => {
      const p = r[f];
      uu(n, f).forEach((u) => {
        let T;
        const C = (b, P) => {
          if ((Jt(this.props.focused) ? this.props.focused : this.__isFocused__) && P !== this.__lastChildSequence__)
            return this.context.hotKeyParent && this.context.hotKeyParent.childHandledSequence(P), p(b, P);
        };
        Mr(u) && (T = u.action, u = u.sequence), o.push({ callback: C, action: T, sequence: u });
      });
    }), i && (i.reset(), o.forEach(({ sequence: f, callback: p, action: l }) => i.bind(f, p, l)));
  }
  /**
   * Stores a reference to the last key sequence handled by the most direct
   * descendant HotKeys component, and passes that sequence to its own most
   * direct HotKeys ancestor for it to do the same.
   *
   * This reference is stored so that parent HotKeys components do not try
   * to handle a sequence that has already been handled by one of its
   * descendants.
   */
  childHandledSequence(r = null) {
    this.__lastChildSequence__ = r, this.context.hotKeyParent && this.context.hotKeyParent.childHandledSequence(r);
  }
  /**
   * Renders the component's children wrapped in a FocusTrap with the necessary
   * props to capture keyboard events
   *
   * @returns FocusTrap with necessary props to capture keyboard events
   */
  render() {
    const {
      /**
       * Props used by HotKeys that should not be passed down to its focus trap
       * component
       */
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      keyMap: r,
      handlers: n,
      focused: o,
      // @ts-ignore
      attach: i,
      attachRef: f,
      children: p,
      ...l
    } = this.props;
    return /* @__PURE__ */ ve(tt, { ...l, onFocus: this.onFocus, onBlur: this.onBlur, children: /* @__PURE__ */ ve(et.Provider, { value: this.getContext(), children: p }) });
  }
  /**
   * Updates the internal focused state and calls the onFocus prop if it is
   * defined
   */
  onFocus(...r) {
    this.__isFocused__ = !0, this.props.onFocus && this.props.onFocus(...r);
  }
  /**
   * Updates the internal focused state and calls the onBlur prop if it is
   * defined.
   *
   * Also registers a null sequence as being handled by this component with
   * its ancestor HotKeys.
   */
  onBlur(...r) {
    this.__isFocused__ = !1, this.props.onBlur && this.props.onBlur(...r), this.context.hotKeyParent && this.context.hotKeyParent.childHandledSequence(null);
  }
}
q(cu, "contextType", et);
export {
  tt as FocusTrap,
  cu as HotKeys
};
